import { useEffect, useState } from "react";

export default function Nav({ onNavigate }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 w-full z-50 border-b transition-[background-color,border-color] duration-500 ${
        scrolled
          ? "bg-[#121212]/70 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-20 px-6 sm:px-12 lg:px-20">
        <button
          data-testid="nav-brand"
          onClick={() => onNavigate(0)}
          className="text-sm sm:text-base uppercase tracking-[0.3em] font-normal text-white transition-opacity duration-300 hover:opacity-60"
        >
          Chef Oksana ODonnell
        </button>
        <button
          data-testid="nav-inquire-button"
          onClick={() => onNavigate("#inquiry")}
          className="border border-white/30 px-6 sm:px-8 py-2.5 text-[11px] uppercase tracking-[0.3em] text-white transition-colors duration-300 hover:bg-white hover:text-[#121212]"
        >
          Inquire
        </button>
      </div>
    </header>
  );
}
